import {
  clearPriceCalculationState,
  getStoredProductStart,
} from "Store/priceCalculation/priceCalculationSlice";

import { useOptionalCart } from "Store/cart/cartHooks";
import { CartEntity } from "Store/cart/cartInterfaces";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { getSavedStateFromLocalStorageStart } from "Store/localStorage/localStorageSlice";
import { useIsCustomerNameNinIdentificationValid } from "Store/userIdentification/userIdentificationSelectors";
import { isAuthenticated } from "Utils/KeycloakWrapper";
import { getCartIdFromCookie } from "Utils/cookies/cookiesUtil";
import { isDefined } from "Utils/functions";
import { getProductEditQueryParams } from "Utils/navigation/queryParameterUtils";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";

export const useExistingProductState = (type: INSURANCE_NAME_VALUE): void => {
  const dispatch = useDispatch();
  useEffect(() => {
    const { cartId, productId } = getProductEditQueryParams();
    if (cartId && productId) {
      dispatch(getStoredProductStart({ type, cartId, productId }));
    } else {
      dispatch(getSavedStateFromLocalStorageStart());
    }
  }, []);
};

export const useExistingCart = (): CartEntity => {
  const { cartId: cartIdFromQueryParams } = getProductEditQueryParams();
  const cartIdFromCookies = getCartIdFromCookie();

  return useOptionalCart(cartIdFromQueryParams ?? cartIdFromCookies);
};

export const useHasBeenIdentified = (): boolean => {
  const isInEditMode = useIsEditMode();
  const hasValidNameNin = useIsCustomerNameNinIdentificationValid();
  const hasCartIdInCookies = isDefined(getCartIdFromCookie());
  return (
    isAuthenticated() || hasValidNameNin || hasCartIdInCookies || isInEditMode
  );
};

export const useIsEditMode = (): boolean => {
  const history = useHistory();
  const { cartId } = getProductEditQueryParams(history.location.search);
  return isDefined(cartId);
};

export const useCheckPriceStateCleanup = (): void => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(clearPriceCalculationState());
    };
  }, []);
};
